import styled from 'styled-components';
import ArrowBackIcon from '../../../icons/ArrowBack';
import ArrowForwardIcon from '../../../icons/ArrowForward';
import Button from '../../../styles/Button/Button';

export const PaginationWrapper = styled.ul.attrs({
  className:
    'bg-transparent box-border flex flex-wrap grid-cols-1 items-center justify-between list-none pb-24 m-0 pt-[50px] w-full'
})`
  grid-column: span results-container;
`;

export const NavButton = styled(Button)`
  && {
    background: white;
    min-width: 56px;
    height: 56px;
    border-radius: 3px;
    padding: 0;
    font-weight: bold;
    color: ${props =>
      props.disabled
        ? props.theme.carvana.gray.medium
        : props.theme.carvana.white.primary};
    background-color: ${props =>
      props.disabled
        ? props.theme.carvana.gray.light
        : props.theme.carvana.blue.primary};
    svg {
      fill: ${props =>
        props.disabled
          ? props.theme.carvana.gray.medium
          : props.theme.carvana.white.primary};
    }
    &:hover {
      background-color: ${props =>
        props.disabled
          ? props.theme.carvana.gray.light
          : props.theme.carvana.blue.hover};
      svg {
        fill: ${props =>
          props.disabled
            ? props.theme.carvana.gray.medium
            : props.theme.carvana.white.primary};
      }
    }
    span {
      color: ${props =>
        props.disabled
          ? props.theme.carvana.gray.medium
          : props.theme.carvana.white.primary};
    }
    ${props =>
      props.disabled && 'box-shadow: inset 0 1px 2px rgba(0,0,0,0.07);'}
    @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
      padding: 0 20px;
    }
  }
`;

export const OuterButtonNext = styled(NavButton)`
  && {
    width: 32px;
    height: 56px;
    min-width: 32px;
    margin: 0 0 0 5px;
    svg {
      width: 16px;
    }
    @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
      width: auto;
      min-width: 56px;
      height: 56px;
      margin: 0 0 0 10px;
    }
  }
`;

export const OuterButtonBack = styled(NavButton)`
  && {
    width: 32px;
    height: 56px;
    min-width: 32px;
    margin: 0 5px 0 0;
    svg {
      width: 16px;
    }
    @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
      width: auto;
      min-width: 56px;
      height: 56px;
      margin: 0 10px 0 0;
    }
  }
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  text-align: center;
`;

export const PaginationText = styled.span.attrs({
  'data-qa': 'pagination-text'
})`
  display: inline-block;
  font-size: 14px;
  text-align: center;
  font-weight: 700;
  white-space: nowrap;
  color: ${props => props.theme.carvana.blue.dark};
`;

export const ArrowBack = styled(ArrowBackIcon)`
  width: 6px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin-right: 8px;
  }
`;

export const ArrowForward = styled(ArrowForwardIcon)`
  width: 6px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin-left: 8px;
  }
`;
